import React, { Component, PropTypes } from "react";
import { NitroLoading, NitroTabs, NitroSearchBar } from "nitro-components";

import styled from "styled-components";

import DriverList from "./DriverList";

const PanelHeader = styled.section`
	padding: 40px 40px 25px 40px;
	background: ${props => props.theme.color.secondary};
	display: flex;
	align-items: center;
	flex-direction: column;
`;

const SearchContainer = styled.div`
	position: relative;
	width: 100%;
	borderRadius:2px;
	background-color:rgba(255,255,255,0.3);
	border:none;
	margin-top: 30px;
	padding: 0px 10px;
  	 & input {
	  color:${props => props.theme.color.white};
	}
`;

const hintStyle = {
	left: "20px",
	fontSize: "14px",
	fontFamily: "noto-sans-regular",
	height: "22px",
	right: "0",
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis",
	lineHeight: "18px",
	color: "#fff"
};

class DriversPanel extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedTab: "allDriver",
			driverData: this.props.data
		};
	}

	componentDidUpdate(prevProps) {
		console.log("this.props");
		console.log(this.props);
		if (prevProps.data !== this.props.data && this.props.data.length > 0) {
			this.setState({
				driverData: this.props.data
			});
		}
	}

	switchTabs = tab => {
		this.setState({
			selectedTab: tab.key
		});
		this.props.getUpdatedDriverList(tab.key);
	};

	search = text => {
		this.props.onSearchDriver(text.toLowerCase());
	};

	render() {
		const { data } = this.props;
		const { selectedTab } = this.state;

		const tabs = [
			{
				label: "All drivers",
				key: "allDriver"
			},
			{
				label: "Drivers at risk",
				key: "riskyDrivers"
			}
		];

		if (data) {
			return (
				<div>
					<PanelHeader>
						<NitroTabs
							data={tabs}
							active={selectedTab}
							action={this.switchTabs}
							variant="white"
							underline
							center
						/>
						<SearchContainer>
							<NitroSearchBar
								float="left"
								hintText={"Find driver"}
								action={this.search}
								width={250}
								textFieldHintStyle={hintStyle}
								variant="white"
								underlineShow={false}
							/>
						</SearchContainer>
					</PanelHeader>
					<DriverList
						data={data}
						onSelectDriver={this.props.onSelectDriver}
					/>
				</div>
			);
		} else {
			return <NitroLoading center thickness={2} size={24} />;
		}
	}
}

DriversPanel.propTypes = {
	data: PropTypes.array.isRequired,
	onSelectDriver: PropTypes.func,
	onSearchDriver: PropTypes.func,
	getUpdatedDriverList: PropTypes.func,
	error: PropTypes.bool // TODO .isRequired
};

export default DriversPanel;



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/components/DriversPanel.js